import React from 'react';

const SvgDownload = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 11 14" {...props}>
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="M2.335 5.242a.18.18 0 0 0 0 .256l2.677 2.649a.182.182 0 0 0 .138.052c.05.002.1-.015.138-.052l2.676-2.65a.18.18 0 0 0 0-.255l-.736-.73a.184.184 0 0 0-.259 0L5.853 5.619V1.123c0-.1-.082-.181-.182-.181H4.629c-.1 0-.182.082-.182.18v4.496L3.33 4.513a.184.184 0 0 0-.258 0l-.737.73zM9.888 7.35c-.04-.045-.093-.045-.093-.045h-2.34v1.23h1.23v3.25h-7.07v-3.25h1.229v-1.23H.512s-.057 0-.103.05c-.037.038-.037.092-.037.092v5.41c0 .087.072.157.159.157h9.236a.16.16 0 0 0 .16-.159V7.434s0-.04-.039-.084z"
    />
  </svg>
);

export default SvgDownload;
